var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.chartdata)?_c('statistics-chart',{attrs:{"chartdata":_vm.chartdata,"loading":_vm.loading,"chartTypeDetailProp":_vm.selectedChartTypeDetail,"chartTypeDetailActive":"","unStacked":""},on:{"changeChartTypeDetail":_vm.changeChartTypeDetail}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }